import { render, staticRenderFns } from "./TableBudgetManagerPending.vue?vue&type=template&id=3a6ce920&"
import script from "./TableBudgetManagerPending.vue?vue&type=script&lang=ts&"
export * from "./TableBudgetManagerPending.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports